import { FC, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSearchContext } from "../../../../../context/searchContext";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { useFilterSearch } from "../../../../../hooks/useFilterSearch";
import useListFilters from "../../../../../hooks/useListFilters";
import useI18n from "../../../../../hooks/useTranslations";
import { AdminText } from "../../../../../http/vertigrip/types/texts";
import { useTextsApi } from "../../../../../http/vertigrip/useTexts";
import { PaginationQuery } from "../../../../../types";
import FlexContent from "../../../../ui/FlexContent";
import { getEditAction } from "../../../../ui/ListItemMenu";
import SearchBar from "../../../../ui/SearchBar";
import Table from "../../../../ui/Table";

type Props = {
  active?: boolean;
};

const Texts: FC<Props> = ({ active }) => {
  const { systemId } = useParams<{ systemId: string }>();
  const i18n = useI18n();
  const navigate = useNavigate();
  const filters = useListFilters({ key: "texts" });
  const aborter = useRef(new AbortController());
  const textsApi = useTextsApi();
  const { setActions, setTitle } = useSearchContext();
  const { searchTerm, handleSearchChange } = useFilterSearch(filters, aborter, "texts");

  const isActiveTab = active ?? true;

  const debouncedValue = useDebounce(searchTerm);

  const query: PaginationQuery = {
    ...filters.state,
    q: debouncedValue,
  };

  const { error, data } = textsApi.useAdminTexts(query, aborter.current.signal);

  useEffect(() => {
    if (!isActiveTab) return;

    setTitle(i18n.translation.texts.plural);
    setActions(
      <SearchBar placeholder={i18n.translation.texts.search} value={searchTerm} onChange={handleSearchChange} />,
    );

    return () => {
      setTitle(undefined);
      setActions(null);
    };
  }, [isActiveTab, searchTerm]);

  return (
    <FlexContent padding>
      <Table<AdminText>
        isTall
        filters={filters}
        head={
          <tr>
            <th align="left">Id</th>
            <th></th>
          </tr>
        }
        items={data?.items}
        renderRow={(item) => (
          <>
            <td>
              <Link
                onClick={(e) => e.stopPropagation()}
                to={`/admin/systems/${systemId}/vertigrip_static_texts/${item.id}`}
              >
                {item.id}
              </Link>
            </td>
          </>
        )}
        onRowClick={(item) => navigate(`/admin/systems/${systemId}/vertigrip_static_texts/${item.id}`)}
        rowActions={(item) => [
          getEditAction(i18n, () => navigate(`/admin/systems/${systemId}/vertigrip_static_texts/${item.id}`)),
        ]}
        total={data?.total}
        error={!!error}
      />
    </FlexContent>
  );
};

export default Texts;
